import { createContext, useContext, type ReactNode } from 'react';

const HoStatusContext = createContext(true);

/**
 * Whether HO is reachable. Apps feed it from @pos/offline; components that need HO read it through
 * `requiresHo` instead of each app wiring its own check.
 */
export function HoStatusProvider({ reachable, children }: { reachable: boolean; children: ReactNode }) {
  return <HoStatusContext.Provider value={reachable}>{children}</HoStatusContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useHoReachable() {
  return useContext(HoStatusContext);
}
